import React from 'react';
import PropTypes from 'prop-types';

function AreaTable({ areas, onEdit, onDelete }) {
  return (
    <div className="w-100" style={{ overflow: 'auto' }}>
      <table className="table custom_table">
        <thead>
          <tr>
            <th>Tên khu vực</th>
            <th>Thị trường</th>
            <th>Tổng chỗ nghỉ</th>
          </tr>
        </thead>
        <tbody>
          {areas.map((item) => (
            <tr key={item.id} style={{ cursor: 'default' }}>
              <td>
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex flex-column gap-1 buttons-group">
                    <div>{item.name}</div>
                    <div>
                      <div className="buttons-action mt-2 d-flex flex-wrap column-gap-3 row-gap-2">
                        <button
                          type="button"
                          className="button-action button-destructive"
                          onClick={() => onDelete(item)}
                        >
                          Xoá
                        </button>

                        <button
                          type="button"
                          className="button-action button-link text-start"
                          onClick={() => onEdit(item)}
                        >
                          Chỉnh sửa
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>{item.market}</td>
              <td>{item.totalPlaces ?? 0}</td>
            </tr>
          ))}

          {areas.length === 0 && (
            <tr>
              <td colSpan={3} className="text-center">
                Không có dữ liệu
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

AreaTable.propTypes = {
  areas: PropTypes.instanceOf(Array),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

AreaTable.defaultProps = {
  areas: [],
  onEdit: () => {},
  onDelete: () => {},
};

export default React.memo(AreaTable);
